export const AJOUTE_DATA_RESTAURANT="AJOUTE_DATA_RESTAURANT";
export const SUPRIMER_DATA_RESTAURANT="SUPRIMER_DATA_RESTAURANT";